import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProtectedRoute({
  component: Component,
  permission,
  ...rest
}) {
  const { permissions = [], loadingPermissions } = useSelector(
    (state) => state.PermissionReducer
  );

  const allowed = !permission || permissions?.includes(permission);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loadingPermissions) return null; // or loader

        return allowed ? (
          <Component {...props} />
        ) : (
          <Redirect to="/403" />
        );
      }}
    />
  );
}
